import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import DashboardPage from './pages/DashboardPage';
import EditorPage from './pages/EditorPage';
import Layout from './components/Layout';

function App() {
  return (
    <>
      {/* Subtle film grain overlay for cinematic feel */}
      <div className="film-grain" aria-hidden="true" />

      <Routes>
        {/* Landing page has its own layout */}
        <Route path="/" element={<LandingPage />} />

        {/* App pages use dashboard layout */}
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/editor/:clipId" element={<EditorPage />} />
          <Route path="/editor" element={<EditorPage />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
